export default __webpack_public_path__ + "static/media/pause.21c97880.png";